import { useState } from "react";
import { requestGetChangeHistorySpace } from "services/settings/spaceAdmin/aboutSpaceAdmin";

const useSpaceChangeHistory = ({
	loadingRequest, form
}) => {
    const [history, setHistory] = useState([]);
    async function fillHistory() {
        const { id } = form;
        if (!id) return;
        loadingRequest.show("Cargando historial...");
        const data = await requestGetChangeHistorySpace(id);
        setHistory(data);
        loadingRequest.hide();
    }
	return {
		value: history,
		fill: fillHistory
	};
}
	
export default useSpaceChangeHistory;